import { WizCommand, WizEventManager } from "@wizeoo/akm-component-lib";
import { Model } from "../../model/model";
import { COMPUTE_CALL_MODE, ComputeEngineResult, ComputeFilter, ComputeRequest, ComputeSort } from "./compute.request";
import { BaselineEngine, FeiKeyDef, IBaseline, KEY_KIND, WidgetLine, WizConstants } from "@wizeoo/akm-compute-lib";
import { FeiVO } from "../../vo/workingdata/fei.vo";
import { EnvironnementManager } from "../../model/environnement.manager";
import { ExternalAPI } from '../../model/external-api';
import { Baseline, WidgetSort } from "@wizeoo/akm-message-lib";
import { IWidget, IWidgetFilter } from "../../manager/widgets/i-widget";
import { ColDef } from 'ag-grid-community';
import { Pivot } from "../../components/widgets/pivot/pivot.component";
import { WizColDef } from "../../manager/workingdata/fei.engine";
import { ALK_EVENT_TYPE } from "../../model/enums";
import { AlkEvent } from "../../framework/events/alk.event";

export class ComputeCallCommand extends WizCommand<ComputeEngineResult> {

  protected model: Model = null;

  constructor(model: Model) {
      super();
      this.model = model;
  }

  public widget: IWidget; // stockage par widget sur le FEI
  public fei: FeiVO; // la conf d'appel
  public method: COMPUTE_CALL_MODE;
  public request: ComputeRequest;

  /**
   * détermination du type
   * @param fkd 
   * @returns KEY_KIND
   */
  private kindFromFKD(fkd: FeiKeyDef): KEY_KIND {
    let kind: KEY_KIND = null;
    if(fkd) {
      if(fkd.isKey) {
        if(fkd.isFilterKey) {
          kind = KEY_KIND.FILTER_KEY;
        } else {
          kind = KEY_KIND.KEY;
        }
      } else {
        if(fkd.isMeasure) {
          kind = KEY_KIND.MEASURE;
        } else {
          kind = KEY_KIND.SCEN;
        }
      }
    }
    return kind;
  }

  /**
   * construction de la requête
   * @returns 
   */
  private buildRequest(): void {
    
    this.request = {
      method: this.method, 
      domain: this.fei.vision.domain,
      bu: this.fei.vision.businessUnitCode,
      vision: this.fei.vision.code,
      scenario : {userLocale: this.model.currentLocaleCode, buLocale: this.model.buLocaleCode},
      criteria : {  scenario: this.fei.scenario, 
                    level: this.fei.visionStepLevel,
                  }
    };
  }

  /**
   * 
   * @param cr alimente les filtres sur la requête, pour GET et COUNT
   */
  private buildRequestFilters(): void {
    // les éléments nécessaires à la construction du filter
    let kind: string;
    let code: string;
    let position: number;

    //#### construction des filters
    let compFilters: ComputeFilter[] = [];
    let compFilter: ComputeFilter;

    // prendre le master

    let filter: IWidgetFilter; // les filtres qu'on va jouer

    // prise de lignes sur un éventuel Master
    let masterLines: WidgetLine[] = this.model.widgetEngine.getMasterSelected(this.widget);
    if(masterLines?.length > 0) { // filtre sur les lignes du master
      // console.log('masterLines', masterLines);
      let masterKeySize: number = masterLines[0].key.split(WizConstants.KEY_SEPARATOR).length; // nb d'éléments pour construire la clé
      let thisKeySize: number = this.fei.visionKeys.length; // nombre d'éléments pour moi
      // si c'est pareil, on met -1 pour par faire de traitements inutiles
      let targetKeySize: number = masterKeySize === thisKeySize ? -1 : masterKeySize;
      // TODO prendre les children le master est peut-être un pivot
      compFilter = {kind: KEY_KIND.MASTER, code: null, invalues: [...masterLines.map(wl => wl.key)], position: targetKeySize};
      compFilters.push(compFilter);
    }

    
    // filtre user
    if((this.model.widgetEngine.userGlobalFilter?.size > 0)) { // pas de filtre, sortie directe
      // console.log('filtre utilisateur', WidgetEngine.userGlobalFilter);
      [...this.model.widgetEngine.userGlobalFilter.keys()].forEach(fdKey => {
        let myFKD: FeiKeyDef = this.fei.keyMap.get(fdKey);
        let filterKeys: Set<string> = this.model.widgetEngine.userGlobalFilter.get(fdKey);
        if(!!myFKD && filterKeys) { // je ne filtre que sur ce que je possède    
          kind = this.kindFromFKD(myFKD);
          code = myFKD.fullCode;
          position = !!myFKD.indexInKey ? myFKD.indexInKey + 1 : null;

          compFilter = {kind, code, invalues: [...filterKeys.values()], position};
          compFilters.push(compFilter);
        }
      });
    }

    // filtre global
    if(!!this.model.widgetEngine.globalFilter) { 
      let globalFilter: IWidget = this.model.widgetEngine.checkGlobalFilter();
      if(globalFilter.filters) { // filtre actifs sur le global
        for (var i = 0, len = globalFilter.filters.size; i < len; i++) {
          filter = [...globalFilter.filters.values()][i];
          if(this.fei?.keyMap?.has(filter.fkd.fullCode)) { // je ne filtre que sur ce que je possède
            if (filter.active) {
              compFilter = this.buildCompFilter(filter);
              compFilters.push(compFilter);
            }
          }
        }
      }
    }

    // mes filtres
    if(this.widget.filters) { 
      for (var i = 0, len = this.widget.filters.size; i < len; i++) {
        filter = [...this.widget.filters.values()][i];
        if (filter.active) {
          let myFKD: FeiKeyDef = this.fei.keyMap.get(filter.fkd.fullCode); // on prend le FKD du FEI pour la position
            if (filter.active) {
              compFilter = this.buildCompFilter(filter);
              compFilters.push(compFilter);
            }
        }
      }
    }
    this.request.criteria.filter = compFilters;
  }

  /**
   * alimentation du computeFilter
   * @param filter 
   * @returns ComputeFilter
   */
  private buildCompFilter(filter: IWidgetFilter): ComputeFilter {
    let myFKD: FeiKeyDef = this.fei.keyMap.get(filter.fkd.fullCode);
    let kind: string = this.kindFromFKD(myFKD);
    let code: string = myFKD.fullCode;
    let position: number = !!myFKD.isKey && !myFKD.isFilterKey ? myFKD.indexInKey + 1 : null;
    
    let regmode: boolean = false;
    let field: string = WizConstants.FIELD_LABEL;
    let regex: string = null;
    let invalues: string[] = null;
    if(!!filter.regex) {
      regmode = true;
      regex = filter.regex;
      if(filter.wcio.fdvf) {
        field = filter.wcio.fdvf;
      }
    } else {
      invalues = [...filter.values?.values() || []];
    }
    return {kind, code, regmode, invalues , regex, field, position};
  }

  /**
   * 
   * @param cr alimente les tris sur la requête, pour GET
   */
  private buildRequestSorts(): void {
    let coldef: WizColDef;
    let kind: string;
    let code: string;
    let ff: string;
    let num: boolean;
    let position: number;

    //#### construction des sorts
    let compSorts: ComputeSort[] = [];
    let compSort: ComputeSort;

    // on prend les vraies colonnes du widget
    let columnMap: Map<string, ColDef> = new Map((this.widget as Pivot).agGrid.columnApi.getAllDisplayedColumns().map(item => [item.getColId(), item.getColDef()]));
    let sorts: WidgetSort[] = this.widget.context.sort;
    sorts?.sort((a, b) => a.sortIndex - b.sortIndex).forEach(ws => {
      coldef = columnMap.get(ws.colId) as WizColDef;
      
      if(coldef?.fkd) {
        let myFKD: FeiKeyDef = this.fei.keyMap.get(coldef.fkd.fullCode); // on prend le FKD du FEI pour la position
        kind = this.kindFromFKD(myFKD);
        code = myFKD.fullCode;
        ff = coldef.fdvfield || WizConstants.FIELD_LABEL;
        num= this.model.dataEngine.datakindIsNumeric(myFKD.datakind);   
        position = !!myFKD.indexInKey ? myFKD.indexInKey + 1 : null;
        compSort = {kind, code, ff, num, position,
          ord: ws.sortIndex, 
          way: ws.sort,
        };
        compSorts.push(compSort);
      }
    });

    this.request.criteria.sort = compSorts;
  }

  /**
   * compte le nombre de lignes pour un widget
   * @param widget 
   */
  public countPagesForWidget(widget: IWidget): ComputeCallCommand {
    this.widget = widget;
    this.fei = widget.fei;
    this.method = COMPUTE_CALL_MODE.COUNT;

    this.buildRequest();
    this.buildRequestFilters();


    // console.log('getPage', request);
    this.configureRemote(EnvironnementManager.envConfig.computeUrl + '/' + ExternalAPI.GET_COMPUTE, this.request);
    return this;
  }

  /**
   * collecte du nombre de BL, BLV et maxNumRev pour le DLO
   */
  public getPage(widget: IWidget): ComputeCallCommand {
    this.widget = widget;
    this.fei = widget.fei;
    this.method = COMPUTE_CALL_MODE.GET;
    

    // TODO TODO prise en compte du filtre global ==> OK
    // TODO TODO prise en compte d'un widget parent
    // TODO vérifier les formules sur filterKeys ==> OK
    // TODO TODO gestion des fkey sur compute ==> OK
    // TODO TODO gestion des filtres en regex


    // requête de base
    this.buildRequest();

    // gestion de l'offset
    try{
      let requestPage = this.fei.requestPage?.get(widget.uid) || widget.context.cmp || 0;
      let pageSize: number = widget.context.cms || 100;
      let maxPage: number = Math.ceil((this.fei.totalSizes?.get(this.widget.uid) || 0) / pageSize);
      if(requestPage > maxPage) {
        requestPage = maxPage;
      }
      
      this.request.criteria.offset = requestPage > 0 ? requestPage - 1: 0;
      this.request.criteria.pageSize = pageSize;
      
      if(this.fei.requestPage?.has(widget.uid)) { // on supprime la demande du fei
        this.fei.requestPage.delete(widget.uid);
      }
    } catch(e: any) {
    }

    this.buildRequestFilters();
    this.buildRequestSorts();

    // console.log('ComputeCallCommand get, offset:', this.request.criteria.offset , ', size:', this.request.criteria.pageSize);

    this.configureRemote(EnvironnementManager.envConfig.computeUrl + '/' + ExternalAPI.GET_COMPUTE, this.request);
    return this;
  }

  wizResult() {
    super.wizResult();
    try {
      if(this.method === COMPUTE_CALL_MODE.COUNT) {
        // console.log('ComputeCallCommand count', this.result);
        if(!this.fei.totalSizes) {
          this.fei.totalSizes = new Map();
        }
        this.fei.totalSizes.set(this.widget.uid, this.result?.totalLines || 0);
        this.fei.computeTime = this.result?.time;
        this.fei.computeRevNumber = this.result?.numRev;
        WizEventManager.dispatchEvent(this.widget, new AlkEvent(ALK_EVENT_TYPE.COMPUTE_COUNT, this.widget));

      } else if(this.method === COMPUTE_CALL_MODE.GET) {
        // alimentation du pool de pages par widget sur le FEI
        // console.log('ComputeCallCommand GET', this.result);
        if (this.result?.lines?.length > 0) {
            
          let wls: WidgetLine[] = [];
          this.result.lines.forEach((ibaseline: IBaseline) => {

            this.model.cellMatrixEngine.getMatrix().addRow(ibaseline.l, ibaseline.k, ibaseline.sc, ibaseline);
            let bl: Baseline = BaselineEngine.ibaselineToBaseline(this.fei, ibaseline);
            // construction de la widgetLine
            const widgetline: WidgetLine = this.model.dataEngine.baselineToWidgetLine(this.fei, bl.scen, bl);
            wls.push(widgetline);
           // this.fei.addLine(widgetline);

          });

          if(!this.fei.pages) {
            this.fei.pages = new Map();
          }
          if(!this.fei.pages.has(this.widget.uid)) {
            this.fei.pages.set(this.widget.uid, new Map());
          }
          this.fei.pages.get(this.widget.uid).set(this.request.criteria.offset + 1, wls);
          
          this.widget.context.cmp = this.request.criteria.offset + 1;
          this.widget.updateContext(this.widget.context);
          WizEventManager.dispatchEvent(this.widget, new AlkEvent(ALK_EVENT_TYPE.COMPUTE_GET_RESULT, this.widget));
        }
      }

      
    } catch(e: any) {
      console.log('ComputeCallCommand error',e , this);
    }
  }

}